import { ReactNode } from "react";

export function AdminNavbarGroup({ children }: { children: ReactNode }) {
  return (
    <div className="flex shrink-0 items-center gap-1 rounded-lg bg-zinc-100 pl-1 pr-2.5 shadow-inner ring-1 ring-zinc-950/5">
      {children}
      <span className="ml-1 text-[10px] font-semibold uppercase tracking-wider text-zinc-400">
        Admin
      </span>
    </div>
  );
}
